// extracted by mini-css-extract-plugin
export default {"hero_heading":"styles_hero_heading__SlFPn","small_note":"styles_small_note__DhjVq","nomal_text":"styles_nomal_text__gCXn5"};